

import "./Assets/fonts/Iransans/Iransans.css";
import "./Assets/css/App.css";
import axios from "axios";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LMDAside from "./Component/General/LMD/LMDAside";
import appsettings from './appsettings.json'
import { useDispatch, useSelector } from "react-redux";
import { setEmail, setMobile, setName, setRFToken, setRole, setToken, setUserAccess, setUsername } from "./redux/user/userAction";
import Navbar from "./Component/General/Navbar";
function App() {
  const [user, setUser] = useState({});
  const [userFname, setUserName] = useState("");
  // const [userAccess, setUserAccess] = useState(false);
  // const [stationAccess, setStationAccess] = useState(false);
  // const [reportAccess, setReportAccess] = useState(false);
  // const [groupAccess, setGroupAccess] = useState(false);
  const {token,rftoken,userAccess,role,name}=useSelector(state=>state.user)
  const theme=localStorage.getItem("theme")
  const dispatch=useDispatch()
 

  //basic interceptors setting for axios 

  const baseURL=appsettings.BaseApiUrl
  axios.interceptors.request.use(request => {
    // console.log(request);
    // Edit request config
    request.baseURL=baseURL
    if(token){
      request.headers.Authorization = `Bearer ${token}`
  
      request.headers.set("Access-Control-Allow-Origin","*")
      request.headers.set("Access-Control-Allow-Methods","*")
    }
    
    return request;
  }, error => {
    // console.log(error);
    return Promise.reject(error);
  });
  var errCount=0;
  axios.interceptors.response.use(response => {
    // console.log(response);
    // Edit response config
    return response;
  }, error => {
    console.log(rftoken);
    console.log("errr=>",error.config);
    //if request get unauthorized error in response then get stored refresh token and then try to 
    //call refresh api if response was ok then store new tokens else clear localstorage and kick out user 
    if(error.response.status===401)
    {
      console.log('token expired');
      if(rftoken!==null ||rftoken!==undefined){
        axios.post(`/api/user/refresh`,{token:rftoken})
        .then(res=>{
          console.log('refreshed');
          console.log(res.data);
          dispatch(setToken(res.data.token))
          dispatch(setRFToken(res.data.refreshToken))

            error.config.headers['Authorization']= `Bearer ${res.data.token}`
            console.log(error.config);
            return axios.request(error.config)
        })
        .catch(()=>{
          localStorage.clear();
          window.location.href="/";
        })
        
      }
      
    }
    return Promise.reject(error);
  });
  
  const navigate = useNavigate();

  //this function gets user detail from api and then store them in redux 
  let getUser = () => {
    axios.get(`/api/user`).then((res) => {
      // setUser(res.data);
      console.log(res.data);
      //create user role name base on recieved data 
      var role=''
      switch (res.data.type) {
        case 0:
          role = "مدیرکل";
          break;
        case 1:
          role = "مدیر";
          break;
        case 2:
          role = "کاربر";
          break;
          default:
            role=''
      }

      //store user details in redux 
      dispatch(setName(res.data.fullName))
      dispatch(setEmail(res.data.email))
      dispatch(setUsername(res.data.username))
      dispatch(setMobile(res.data.mobile))
      dispatch(setRole(role))
      dispatch(setUserAccess(res.data.accesses))
    });
  };
   
  useEffect(() => {
   
    if ( token) {
      getUser();
    } else {
      if(window.location.pathname==="/forget")return
      if(window.location.pathname==="/")return
      navigate('/')
    }
  }, [token]);

  useEffect(()=>{
    setUserName(name)
  },[name])
  return (
    <>
     <Navbar/>
      <div className="container-fluid" style={{ padding: 0 }}>
        {token && (
          <>
            <LMDAside/>
          </>
        )}

        <Outlet
         
        />
      </div>
    </>
  );
}

export default App;
